import FilterAdapter from '@/components/query/adapters/filter/filter-adapter';
import FilterSet from '@/components/query/filter-set';
import gridFilters from '@/modules/segments/data/grid-filters';
import {DataExportModel} from '@/common/models/data-export-model';
import SortingOrders from '@/components/grid/sorting-orders';
import {mapGetters, mapState} from 'vuex';
import transactionsDataExportFieldsMap from '@/data/transactions-data-export-fields-map';

export default {
    watch: {
        'activeSegment.id': {
            handler(newId, oldId) {
                if (newId !== oldId) {
                    this.filterSet = new FilterSet({
                        ...gridFilters[this.activeSegment.data.type],
                        store: this.$store,
                        defaultSortBy: this.activeSegment.data.sortBy,
                        id: newId,
                    });
                }
            },
            immediate: true,
        },
    },
    computed: {
        ...mapGetters({
            preferences: 'user/preferences',
        }),
        ...mapState('segments', ['exportSort']),
        columns() {
            if (this.preferences.columns[this.activeSegment.id]
                && this.preferences.columns[this.activeSegment.id].columns) {
                return this.preferences.columns[this.activeSegment.id].columns;
            }
            return this.activeSegment.data.columns;
        },
        sortBy() {
            if (this.exportSort) {
                const [[field, sort]] = Object.entries(this.exportSort);
                return `${sort === SortingOrders.ascending ? '' : '-'}${field}`;
            }
            return this.activeSegment.data.sort;
        },
    },
    methods: {
        mapExports([...columns]) {
            // Workaround to force the export of both first and last name
            // https://jira.ilabsinc.com/browse/GWY-13331
            const firstNameIndex = columns.indexOf('firstName');
            const lastNameIndex = columns.indexOf('lastName');

            // only add the lastname column if not present
            if (firstNameIndex >= 0 && lastNameIndex < 0) {
                columns.splice(firstNameIndex + 1, 0, 'lastName');
            }

            // Edge case for gateway responses messages, gateway response code
            // (including AVS and CVV) and DCC related fields.
            return columns.map((column) => {
                if (column.includes('gateway.') || column.includes('dcc.')) {
                    return transactionsDataExportFieldsMap[column];
                }
                return column;
            });
        },
        async exportData() {
            try {
                const {
                    type,
                    name,
                } = this.activeSegment.data;
                const parsedName = name.toLowerCase().replace(/\s/g, '-');
                const dataExportName = `${parsedName}-${this.$tz().getUTC().format('YYYY-MM-DD-hA')}`;
                const activeFilters = (this.activeFilters && this.activeFilters.length)
                    ? FilterAdapter.convertFiltersToString(
                        {filterSet: gridFilters[type], query: this.activeFilters},
                    )
                    : null;
                const parsedColumns = this.mapExports(this.columns).map(field => field.replace(/\./g, '/'));
                const data = new DataExportModel({
                    name: dataExportName,
                    resource: type,
                    format: 'csv',
                    arguments: {
                        filter: activeFilters,
                        sort: this.sortBy,
                    },
                    fields: parsedColumns,
                }).getPayload();
                await this.$api(({dataExports}) => dataExports.queue({data}));
                this.$toast.positive(`Exporting data to CSV`);
                this.$resetPolling();
            } catch (error) {
                this.$toast.fromError(error);
            }
        },
    },
};
